import { Container, Row, Col, Card } from "react-bootstrap";

export default function MediaNews() {
  return (
    <Container fluid className="py-4 bg-white">
      <h2 className="text-center text-primary fw-semibold">News</h2>
      <Row className="mt-4 justify-content-center">
        <Col md={12}>
          <Card className="border-0 mb-3 p-3" style={{ boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1), 0px -2px 8px rgba(0, 0, 0, 0.1)", borderRadius: "14px" }}>
            <Card.Body>
              <Card.Title className="text-primary fw-semibold">
                Blueberry Infratech Expands Operations
              </Card.Title>
              <Card.Text className="text-muted">
                Blueberry Infratech announces the expansion of its construction
                projects into new territories.
              </Card.Text>
              <Card.Text className="text-secondary small">
                Published on: March 22, 2025
              </Card.Text>
            </Card.Body>
          </Card>
          <Card className="border-0 p-3" style={{ boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1), 0px -2px 8px rgba(0, 0, 0, 0.1)", borderRadius: "14px" }}>
            <Card.Body>
              <Card.Title className="text-primary fw-semibold">
                Sustainable Building Initiative Launched
              </Card.Title>
              <Card.Text className="text-muted">
                A new initiative focuses on eco-friendly construction methods
                for a sustainable future.
              </Card.Text>
              <Card.Text className="text-secondary small">
                Published on: March 15, 2025
              </Card.Text>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}
